import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Skeletons } from 'ui/components/skeleton';

import { Closing } from 'services/action';

import { FormGeneral } from '../form';

const initialState = {
  showDelete: false,
  showUpdate: false,
};

export const Action = ({ data, isLoading }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const [{ showDelete, showUpdate }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false, showUpdate: false}));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Closing.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      History.replace('/accounting/closing');
    }
  };

  const StandardAction = () => {
    return (
      <>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
        >
          <button
            className={cn('btn btn-primary px-2')}
            onClick={() =>
              setState((prevState) => ({ ...prevState, showUpdate: true }))
            }
          >
            <Fi.FiEdit size="17" />
          </button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
        >
          <button
            className={cn('btn btn-danger px-2')}
            onClick={() =>
              setState((prevState) => ({ ...prevState, showDelete: true }))
            }
          >
            <Fi.FiTrash2 size="17" />
          </button>
        </OverlayTrigger>
      </>
    );
  };

  return (
    <div className="d-flex align-items-center gap-1 px-md-3 px-2  px-md-0 pb-2 pb-md-0">
      {isLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <StandardAction />
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal update */}
      <Modal
        show={showUpdate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Tutup Buku</Modal.Title>
        </Modal.Header>
        <FormGeneral
          data={data}
          onClose={() => {
            $handleClose();
          }}
        />
      </Modal>
    </div>
  );
};
